import React from 'react';
import ProjectContent from '../components/ProjectContent';

const QuakeUp = () => <ProjectContent projectName='QuakeUp'/>;

export default QuakeUp;